import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { Flex } from 'Components/UI/_Legacy'

export const Container = styled(Flex).attrs({
  pt: [88, 88, 100, 100, 120],
  pb: [80, 80, 100, 100, 120],
})`
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${themeGet('colors.almondLight')};
  position: relative;
`

export const ContentWrapper = styled.div`
  width: 100vw;
  overflow: hidden;
`
